import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const questionServiceApi = createApi({
    reducerPath: 'questionServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Question'],
    endpoints: (builder) => ({

        // getAllQuestion: builder.query({
        //     query: () => `/v1/question`,
        //     providesTags: ['Question'],
        // }),

        getByChapterId: builder.query({
            query: (id) => `/v1/question/getByChapterId/${id}`,
            providesTags: ['Question'],
        }),

        getQuestionChapters: builder.query({
            query: (id) => `/v1/question/getQuestionChapters/${id}`,
        }),
        // getById: builder.query({
        //     query: () => `/v1/question/getById`,
        //     providesTags: ['Question'],
        // }),

        createQuestion: builder.mutation({
            query: (values) => ({
                url: `/v1/question/add`,
                method: 'POST',
                body: values,
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Question'],
        }),

        updateQuestion: builder.mutation({
            query: ({ id, ...values }) => ({

                url: `/v1/question/update/${id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['Question'],
        }),

        deleteQuestion: builder.mutation({
            query: (id) => ({
                url: `/v1/question/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Question'],
        }),

        reorderQuestions: builder.mutation({
            query: (values) => ({
                url: `/v1/question/reorder`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['Question'],
        }),
    }),
});

export const { useCreateQuestionMutation, useDeleteQuestionMutation, useGetByChapterIdQuery, useUpdateQuestionMutation, useReorderQuestionsMutation, useGetQuestionChaptersQuery } = questionServiceApi;